import { faArrowRight } from '@fortawesome/pro-regular-svg-icons'
import { faCalendarRange } from '@fortawesome/pro-regular-svg-icons/faCalendarRange'
import { Card, Flex, Text } from '@mantine/core'

import { useQueryGetInquiryById } from '@flecto/core/saas'
import { useTranslation } from '@flecto/translations'
import { Badge, Icon, TextDate } from '@flecto/ui'

export type CardInquiryRangeDatesProps = {
  inquiryId: number
}

export function CardInquiryRangeDates({
  inquiryId,
}: CardInquiryRangeDatesProps) {
  const { data } = useQueryGetInquiryById({ inquiryId })
  const { t } = useTranslation('saas', { keyPrefix: 'inquiries' })

  const inquiry = data?.inquiry

  return (
    <Card>
      <Text fw={500} mb='xs'>
        {t('dates')}
      </Text>
      <Text c='dimmed'>{t('dates-desc')}</Text>
      <Flex align='center' gap='xs' mt='md'>
        <TextDate date={inquiry?.start_at ?? ''} variant='datetime-brief' />
        <Icon icon={faArrowRight} mx='sm' color='gray' />
        <TextDate date={inquiry?.end_at ?? ''} variant='datetime-brief' />
        {inquiry?.flexible_dates && (
          <Badge
            ml='sm'
            color='green'
            leftSection={
              <Icon
                icon={faCalendarRange}
                data-testid='flexible-dates'
              />
            }
          >
            {t('flexible-dates')}
          </Badge>
        )}
      </Flex>
    </Card>
  )
}
